import React from 'react';
import { toggleClasses } from './tailwindClassnames';

type Option = { value: string; label: string };

type SegmentedToggleProps = {
  /** Currently selected option value. */
  value: string;
  /** The toggle options, rendered left-to-right. */
  options: Option[];
  /** Called with the newly selected value (only fires when it changes). */
  onChange: (value: string) => void;
  /** Optional accessible label for the group. */
  ariaLabel?: string;
  /** Extra classes for the container (e.g. margins). */
  className?: string;
};

/**
 * Shared segmented toggle used across the portal (Code/Builder, View/Edit, …).
 * All toggle styling lives in `toggleClasses` so changing the selected color in
 * one place updates every toggle.
 */
export const SegmentedToggle = ({
  value,
  options,
  onChange,
  ariaLabel,
  className = '',
}: SegmentedToggleProps) => (
  <div
    className={`${toggleClasses.container} ${className}`}
    role="group"
    aria-label={ariaLabel}
  >
    {options.map((opt, i) => (
      <button
        key={opt.value}
        type="button"
        aria-pressed={value === opt.value}
        onClick={() => {
          if (value !== opt.value) onChange(opt.value);
        }}
        className={`${toggleClasses.option} ${i > 0 ? toggleClasses.divider : ''} ${value === opt.value ? toggleClasses.active : toggleClasses.inactive}`}
      >
        {opt.label}
      </button>
    ))}
  </div>
);
